export class VentaElectronica {
    public constructor(
        public ambiente: number = 0,
        public tipoEmision: number = 0,
        public razonSocial: String = "",
        public ruc: String = "",
        public claveAcceso: String = "",
        public codDoc: String = "",
        public estab: String = "",
        public ptoEmi:String = "",
        public secuencial: String = "",
        public dirMatriz:String = "",
        public fechaEmision:Date = new Date(),
        public tipoIdentificacionComprador:String = "",
        public razonSocialComprador:String = "",
        public identificacionComprador:String = "",
        public totalSinImpuestos:String="",
        public totalDescuento:String="",
        public totalConImpuestos = [],
        public impuestos = [],
        public propina:String="",
        public importeTotal:String="",
        public moneda:String="",
        public pagos = [],
        public detalles = [],
        public infoAdicional = [],
    ){}


/*

*/
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/venta-electronica.ts